export const polit_chat_no_answers_strings = {
    de: [
        'Wir konnten im Wahlprogramm der Partei keine Informationen zu Ihrer Frage finden.',
        'Zu diesem Thema enthält das Parteiprogramm leider keine konkreten Aussagen.',
        'Diese spezifische Frage wird im Wahlprogramm nicht direkt behandelt.',
    ],
    en: [
        "We could not find any information about your question in the party's electoral program.",
        'The party program does not contain any specific statements on this topic.',
        'This specific question is not directly addressed in the electoral program.',
    ],
};

export const no_answers_strings = {
    de: [
        'Leider konnte ich deine Frage nicht direkt in meiner Wissensdatenbank beantworten. Hier sind die relevantesten Informationen, die ich gefunden habe.',
        'Ich konnte deine Frage nicht direkt in meiner Knowledge Base beantworten. Hier ist das Beste, was ich dazu gefunden habe.',
        'Die Antwort auf deine Frage war nicht direkt in meiner Wissensdatenbank vorhanden. Hier sind die relevantesten Inhalte, die ich finden konnte.',
    ],
    en: [
        "I couldn't answer your question directly from my experimental-knowledge base. Here are the most relevant pieces of information I found.",
        "Your question couldn't be answered directly from my experimental-knowledge base. Here is the best information I could find.",
        'I was unable to find a direct answer to your question in my experimental-knowledge base. Here are the most relevant details I could gather.',
    ],
    es: [
        'No pude responder directamente a tu pregunta desde mi base de conocimientos. Aquí están los contenidos más relevantes que encontré.',
        'Tu pregunta no pudo ser respondida directamente desde mi base de conocimientos. Aquí está la mejor información que encontré.',
        'No encontré una respuesta directa a tu pregunta en mi base de conocimientos. Aquí tienes los detalles más relevantes que encontré.',
    ],
    fr: [
        "Je n'ai pas pu répondre directement à ta question depuis ma base de connaissances. Voici les contenus les plus pertinents que j'ai trouvés.",
        "Ta question n'a pas pu être répondue directement depuis ma base de connaissances. Voici les meilleures informations que j'ai trouvées.",
        "Je n'ai pas trouvé de réponse directe à ta question dans ma base de connaissances. Voici les détails les plus pertinents que j'ai pu rassembler.",
    ],
    it: [
        'Non ho potuto rispondere direttamente alla tua domanda dalla mia base di conoscenza. Ecco i contenuti più rilevanti che ho trovato.',
        'La tua domanda non ha potuto essere risolta direttamente dalla mia base di conoscenza. Ecco le informazioni migliori che ho trovato.',
        'Non sono riuscito a trovare una risposta diretta alla tua domanda nella mia base di conoscenza. Ecco i dettagli più rilevanti che ho raccolto.',
    ],
    pt: [
        'Não consegui responder diretamente à sua pergunta na minha base de conhecimento. Aqui estão os conteúdos mais relevantes que encontrei.',
        'Sua pergunta não pôde ser respondida diretamente na minha base de conhecimento. Aqui está a melhor informação que encontrei.',
        'Não consegui encontrar uma resposta direta para a sua pergunta na minha base de conhecimento. Aqui estão os detalhes mais relevantes que reuni.',
    ],
    nl: [
        'Ik kon je vraag niet direct beantwoorden vanuit mijn kennisbank. Hier zijn de meest relevante inhoud die ik heb gevonden.',
        'Je vraag kon niet direct worden beantwoord vanuit mijn kennisbank. Hier is de beste informatie die ik kon vinden.',
        'Ik kon geen direct antwoord op je vraag vinden in mijn kennisbank. Hier zijn de meest relevante details die ik kon verzamelen.',
    ],
    ru: [
        'Я не смог напрямую ответить на ваш вопрос из своей базы знаний. Вот наиболее релевантные материалы, которые я нашел.',
        'Ваш вопрос не удалось напрямую ответить из моей базы знаний. Вот лучшая информация, которую я нашел.',
        'Мне не удалось найти прямой ответ на ваш вопрос в моей базе знаний. Вот наиболее релевантные детали, которые я смог собрать.',
    ],
    zh: [
        '我无法直接从我的知识库中回答你的问题。以下是我找到的最相关的内容。',
        '你的问题无法直接从我的知识库中得到回答。以下是我找到的最佳信息。',
        '我在我的知识库中找不到你的问题的直接答案。以下是我能找到的最相关的细节。',
    ],
    ja: [
        '知識ベースから直接あなたの質問に答えることができませんでした。ここにあなたの質問に関して見つけた最も関連性の高い内容があります。',
        '知識ベースから直接あなたの質問に答えることができませんでした。ここに私が見つけた最も良い情報があります。',
        '知識ベースにはあなたの質問に対する直接の回答がありませんでした。ここに見つけた最も関連性の高い詳細があります。',
    ],
    ko: [
        '내 지식 베이스에서 직접 질문에 답할 수 없었습니다. 여기 당신의 질문에 대해 찾은 가장 관련성이 높은 내용입니다.',
        '내 지식 베이스에서 직접 질문에 답할 수 없었습니다. 여기 제가 찾은 최고의 정보입니다.',
        '내 지식 베이스에서 질문에 대한 직접적인 답변을 찾을 수 없었습니다. 여기 제가 찾은 가장 관련성이 높은 세부 사항입니다.',
    ],
    ar: [
        'لم أتمكن من الإجابة على سؤالك مباشرة من قاعدة المعرفة الخاصة بي. هنا أهم المحتويات التي وجدتها لسؤالك.',
        'لم أتمكن من الإجابة على سؤالك مباشرة من قاعدة المعرفة الخاصة بي. هنا أفضل المعلومات التي وجدتها.',
        'لم أتمكن من العثور على إجابة مباشرة على سؤالك في قاعدة المعرفة الخاصة بي. هنا أهم التفاصيل التي وجدتها.',
    ],
    hi: [
        'मैं आपके प्रश्न का सीधे अपने ज्ञान आधार से उत्तर नहीं दे सका। यहां आपके प्रश्न के लिए मैंने जो सबसे प्रासंगिक सामग्री पाई है।',
        'आपके प्रश्न का उत्तर सीधे मेरे ज्ञान आधार से नहीं दिया जा सका। यहां मैंने जो सबसे अच्छी जानकारी पाई है।',
        'मैंने अपने ज्ञान आधार में आपके प्रश्न का सीधा उत्तर नहीं पाया। यहां मैंने जो सबसे प्रासंगिक विवरण पाया है।',
    ],
    bn: [
        'আমি আপনার প্রশ্নের সরাসরি উত্তর আমার জ্ঞানভাণ্ডার থেকে দিতে পারিনি। এখানে আপনার প্রশ্নের জন্য আমি যে সবচেয়ে প্রাসঙ্গিক বিষয়বস্তু পেয়েছি তা দেওয়া হল।',
        'আপনার প্রশ্নের সরাসরি উত্তর আমার জ্ঞানভাণ্ডার থেকে দেওয়া যায়নি। এখানে আমি যে সেরা তথ্য পেয়েছি তা দেওয়া হল।',
        'আমি আমার জ্ঞানভাণ্ডারে আপনার প্রশ্নের সরাসরি উত্তর খুঁজে পাইনি। এখানে আমি যে সবচেয়ে প্রাসঙ্গিক বিবরণ পেয়েছি তা দেওয়া হল।',
    ],
    ur: [
        'میں آپ کے سوال کا براہ راست جواب اپنے علم کے ذخیرے سے نہیں دے سکا۔ یہاں آپ کے سوال کے بارے میں جو میں نے سب سے متعلقہ مواد پایا ہے۔',
        'آپ کے سوال کا براہ راست جواب میرے علم کے ذخیرے سے نہیں دیا جا سکا۔ یہاں میں نے جو سب سے بہترین معلومات پائی ہیں۔',
        'مجھے اپنے علم کے ذخیرے میں آپ کے سوال کا براہ راست جواب نہیں ملا۔ یہاں میں نے جو سب سے متعلقہ تفصیلات پائی ہیں۔',
    ],
    tr: [
        'Sorunuzu doğrudan bilgi tabanımdan yanıtlayamadım. İşte sorunuzla ilgili bulduğum en alakalı içerikler.',
        'Sorunuz doğrudan bilgi tabanımdan yanıtlanamadı. İşte bulduğum en iyi bilgi.',
        'Bilgi tabanımda sorunuzu doğrudan yanıt bulamadım. İşte bulduğum en alakalı detaylar.',
    ],
    sv: [
        'Jag kunde inte besvara din fråga direkt från min kunskapsbas. Här är det mest relevanta innehållet jag hittade.',
        'Din fråga kunde inte besvaras direkt från min kunskapsbas. Här är den bästa informationen jag hittade.',
        'Jag kunde inte hitta ett direkt svar på din fråga i min kunskapsbas. Här är de mest relevanta detaljerna jag kunde samla.',
    ],
    no: [
        'Jeg kunne ikke svare på spørsmålet ditt direkte fra kunnskapsbasen min. Her er det mest relevante innholdet jeg fant.',
        'Spørsmålet ditt kunne ikke besvares direkte fra kunnskapsbasen min. Her er den beste informasjonen jeg fant.',
        'Jeg kunne ikke finne et direkte svar på spørsmålet ditt i kunnskapsbasen min. Her er de mest relevante detaljene jeg kunne samle.',
    ],
    da: [
        'Jeg kunne ikke besvare dit spørgsmål direkte fra min vidensbase. Her er det mest relevante indhold, jeg fandt.',
        'Dit spørgsmål kunne ikke besvares direkte fra min vidensbase. Her er den bedste information, jeg fandt.',
        'Jeg kunne ikke finde et direkte svar på dit spørgsmål i min vidensbase. Her er de mest relevante detaljer, jeg kunne samle.',
    ],
    fi: [
        'En voinut vastata kysymykseesi suoraan tietopohjastani. Tässä on löytämäni relevantti sisältö.',
        'Kysymykseesi ei voitu vastata suoraan tietopohjastani. Tässä on löytämäni paras tieto.',
        'En löytänyt suoraa vastausta kysymykseesi tietopohjastani. Tässä ovat löytämäni olennaisimmat tiedot.',
    ],
    pl: [
        'Nie mogłem bezpośrednio odpowiedzieć na twoje pytanie z mojej bazy wiedzy. Oto najbardziej istotne treści, które znalazłem.',
        'Twoje pytanie nie mogło być bezpośrednio odpowiedziane z mojej bazy wiedzy. Oto najlepsze informacje, jakie znalazłem.',
        'Nie znalazłem bezpośredniej odpowiedzi na twoje pytanie w mojej bazie wiedzy. Oto najbardziej istotne szczegóły, jakie mogłem zebrać.',
    ],
    cs: [
        'Nemohl jsem přímo odpovědět na vaši otázku z mé databáze znalostí. Zde jsou nejrelevantnější informace, které jsem našel.',
        'Vaše otázka nemohla být přímo zodpovězena z mé databáze znalostí. Zde jsou nejlepší informace, které jsem našel.',
        'Nepodařilo se mi najít přímou odpověď na vaši otázku v mé databázi znalostí. Zde jsou nejrelevantnější podrobnosti, které jsem mohl shromáždit.',
    ],
    sk: [
        'Nemohol som priamo odpovedať na vašu otázku z mojej databázy znalostí. Tu sú najrelevantnejšie informácie, ktoré som našiel.',
        'Vaša otázka nemohla byť priamo zodpovedaná z mojej databázy znalostí. Tu sú najlepšie informácie, ktoré som našiel.',
        'Nepodarilo sa mi nájsť priamu odpoveď na vašu otázku v mojej databáze znalostí. Tu sú najrelevantnejšie podrobnosti, ktoré som mohol zhromaždiť.',
    ],
    hu: [
        'Nem tudtam közvetlenül megválaszolni a kérdését a tudásbázisomból. Itt található a legrelevánsabb tartalom, amit találtam.',
        'A kérdésére nem tudtam közvetlenül válaszolni a tudásbázisomból. Itt van a legjobb információ, amit találtam.',
        'Nem találtam közvetlen választ a kérdésére a tudásbázisomban. Itt vannak a legrelevánsabb részletek, amiket összegyűjtöttem.',
    ],
    ro: [
        'Nu am putut răspunde direct la întrebarea ta din baza mea de cunoștințe. Iată cele mai relevante conținuturi pe care le-am găsit.',
        'Întrebarea ta nu a putut fi răspunsă direct din baza mea de cunoștințe. Iată cele mai bune informații pe care le-am găsit.',
        'Nu am găsit un răspuns direct la întrebarea ta în baza mea de cunoștințe. Iată cele mai relevante detalii pe care le-am adunat.',
    ],
    bg: [
        'Не можах да отговоря директно на въпроса ти от моята база знания. Ето най-релевантните материали, които намерих.',
        'Въпросът ти не можа да бъде отговорен директно от моята база знания. Ето най-добрата информация, която намерих.',
        'Не успях да намеря директен отговор на въпроса ти в моята база знания. Ето най-релевантните детайли, които успях да събера.',
    ],
    el: [
        'Δεν μπορούσα να απαντήσω άμεσα στην ερώτησή σου από τη βάση γνώσεών μου. Εδώ είναι τα πιο σχετικά περιεχόμενα που βρήκα.',
        'Η ερώτησή σου δεν μπορούσε να απαντηθεί άμεσα από τη βάση γνώσεών μου. Εδώ είναι οι καλύτερες πληροφορίες που βρήκα.',
        'Δεν κατάφερα να βρω άμεση απάντηση στην ερώτησή σου στη βάση γνώσεών μου. Εδώ είναι οι πιο σχετικές λεπτομέρειες που μπόρεσα να συγκεντρώσω.',
    ],
    he: [
        'לא הצלחתי לענות על שאלתך ישירות ממאגר הידע שלי. הנה התכנים הכי רלוונטיים שמצאתי.',
        'לא הצלחתי לענות על שאלתך ישירות ממאגר הידע שלי. הנה המידע הטוב ביותר שמצאתי.',
        'לא הצלחתי למצוא תשובה ישירה לשאלתך במאגר הידע שלי. הנה הפרטים הכי רלוונטיים שמצאתי.',
    ],
    fa: [
        'نتوانستم به صورت مستقیم به سؤال شما از پایگاه دانش خود پاسخ دهم. اینجا مرتبط‌ترین محتوایی است که پیدا کردم.',
        'نتوانستم به سؤال شما به صورت مستقیم از پایگاه دانش خود پاسخ دهم. اینجا بهترین اطلاعاتی است که پیدا کردم.',
        'نتوانستم پاسخ مستقیمی به سؤال شما در پایگاه دانش خود پیدا کنم. اینجا مرتبط‌ترین جزئیاتی است که پیدا کردم.',
    ],
    id: [
        'Saya tidak dapat menjawab pertanyaan Anda secara langsung dari basis pengetahuan saya. Berikut adalah konten paling relevan yang saya temukan.',
        'Pertanyaan Anda tidak dapat dijawab secara langsung dari basis pengetahuan saya. Berikut adalah informasi terbaik yang saya temukan.',
        'Saya tidak dapat menemukan jawaban langsung untuk pertanyaan Anda di basis pengetahuan saya. Berikut adalah detail paling relevan yang saya kumpulkan.',
    ],
    ms: [
        'Saya tidak dapat menjawab soalan anda secara langsung dari pangkalan pengetahuan saya. Berikut adalah kandungan paling relevan yang saya temui.',
        'Soalan anda tidak dapat dijawab secara langsung dari pangkalan pengetahuan saya. Berikut adalah maklumat terbaik yang saya temui.',
        'Saya tidak dapat mencari jawapan langsung untuk soalan anda dalam pangkalan pengetahuan saya. Berikut adalah butiran paling relevan yang saya kumpulkan.',
    ],
    th: [
        'ฉันไม่สามารถตอบคำถามของคุณโดยตรงจากฐานความรู้ของฉันได้ นี่คือเนื้อหาที่เกี่ยวข้องมากที่สุดที่ฉันพบ',
        'คำถามของคุณไม่สามารถตอบได้โดยตรงจากฐานความรู้ของฉัน นี่คือข้อมูลที่ดีที่สุดที่ฉันพบ',
        'ฉันไม่พบคำตอบโดยตรงสำหรับคำถามของคุณในฐานความรู้ของฉัน นี่คือรายละเอียดที่เกี่ยวข้องมากที่สุดที่ฉันรวบรวมได้',
    ],
    vi: [
        'Tôi không thể trả lời câu hỏi của bạn trực tiếp từ cơ sở tri thức của mình. Dưới đây là những nội dung liên quan nhất mà tôi tìm thấy.',
        'Câu hỏi của bạn không thể được trả lời trực tiếp từ cơ sở tri thức của tôi. Đây là những thông tin tốt nhất mà tôi tìm thấy.',
        'Tôi không thể tìm thấy câu trả lời trực tiếp cho câu hỏi của bạn trong cơ sở tri thức của mình. Dưới đây là những chi tiết liên quan nhất mà tôi đã thu thập được.',
    ],
    tl: [
        'Hindi ko masagot nang direkta ang iyong tanong mula sa aking experimental-knowledge base. Narito ang pinakanaaangkop na nilalaman na aking natagpuan.',
        'Ang iyong tanong ay hindi masagot nang direkta mula sa aking experimental-knowledge base. Narito ang pinakamainam na impormasyon na aking natagpuan.',
        'Hindi ko natagpuan ang direktang sagot sa iyong tanong sa aking experimental-knowledge base. Narito ang mga pinakanaaangkop na detalye na aking nakalap.',
    ],
    uk: [
        'Я не зміг відповісти на ваше запитання безпосередньо з моєї бази знань. Ось найбільш релевантні матеріали, які я знайшов.',
        'Ваше питання не вдалося безпосередньо відповісти з моєї бази знань. Ось найкраща інформація, яку я знайшов.',
        'Мені не вдалося знайти пряму відповідь на ваше запитання в моїй базі знань. Ось найбільш релевантні деталі, які я зміг зібрати.',
    ],
    be: [
        'Я не змог адказаць на ваша пытанне непасрэдна з маёй базы ведаў. Вось найбольш адпаведныя матэрыялы, якія я знайшоў.',
        'Вашае пытанне не атрымалася непасрэдна адказаць з маёй базы ведаў. Вось лепшая інфармацыя, якую я знайшоў.',
        'Мне не ўдалося знайсці прамы адказ на ваша пытанне ў маёй базе ведаў. Вось найбольш адпаведныя дэталі, якія я змог сабраць.',
    ],
    sr: [
        'Нисам могао директно да одговорим на ваше питање из моје базе знања. Ево најрелевантнијих материјала које сам пронашао.',
        'Ваше питање није могло бити директно одговорено из моје базе знања. Ево најбољих информација које сам пронашао.',
        'Нисам успео да пронађем директан одговор на ваше питање у мојој бази знања. Ево најрелевантнијих детаља које сам успео да прикупим.',
    ],
    hr: [
        'Nisam mogao direktno odgovoriti na vaše pitanje iz svoje baze znanja. Evo najrelevantnijih materijala koje sam pronašao.',
        'Na vaše pitanje nije se moglo direktno odgovoriti iz moje baze znanja. Evo najboljih informacija koje sam pronašao.',
        'Nisam uspio pronaći direktan odgovor na vaše pitanje u svojoj bazi znanja. Evo najrelevantnijih detalja koje sam uspio prikupiti.',
    ],
    sl: [
        'Nisem mogel neposredno odgovoriti na vaše vprašanje iz svoje baze znanja. Tukaj so najbolj relevantne vsebine, ki sem jih našel.',
        'Na vaše vprašanje ni bilo mogoče neposredno odgovoriti iz moje baze znanja. Tukaj so najboljše informacije, ki sem jih našel.',
        'Nisem našel neposrednega odgovora na vaše vprašanje v svoji bazi znanja. Tukaj so najbolj relevantne podrobnosti, ki sem jih uspel zbrati.',
    ],
    mk: [
        'Не можев директно да одговорам на вашето прашање од мојата база на знаења. Еве ги најрелевантните содржини што ги најдов.',
        'Вашето прашање не можеше да се одговори директно од мојата база на знаења. Еве ги најдобрите информации што ги најдов.',
        'Не успеав да најдам директен одговор на вашето прашање во мојата база на знаења. Еве ги најрелевантните детали што ги собрав.',
    ],
    sq: [
        "Nuk munda t'i përgjigjem pyetjes suaj direkt nga baza ime e njohurive. Këtu janë përmbajtjet më relevante që gjeta.",
        "Pyetjes suaj nuk mund t'i jepej përgjigje direkt nga baza ime e njohurive. Këtu janë informacionet më të mira që gjeta.",
        'Nuk munda të gjej një përgjigje direkte për pyetjen tuaj në bazën time të njohurive. Këtu janë detajet më relevante që mblodha.',
    ],
    et: [
        'Ma ei saanud teie küsimusele oma teadmistebaasist otseselt vastata. Siin on kõige asjakohasem sisu, mille leidsin.',
        'Teie küsimusele ei saanud otse teadmistebaasist vastata. Siin on parim teave, mille leidsin.',
        'Ma ei leidnud teie küsimusele otsest vastust oma teadmistebaasist. Siin on kõige asjakohasemad üksikasjad, mille suutsin koguda.',
    ],
    lv: [
        'Es nevarēju tieši atbildēt uz jūsu jautājumu no savas zināšanu bāzes. Lūk, visatbilstošākais saturs, ko es atradu.',
        'Uz jūsu jautājumu nevarēja atbildēt tieši no manas zināšanu bāzes. Lūk, labākā informācija, ko es atradu.',
        'Es nevarēju atrast tiešu atbildi uz jūsu jautājumu savā zināšanu bāzē. Lūk, visatbilstošākās detaļas, ko es varēju savākt.',
    ],
    lt: [
        'Aš negalėjau tiesiogiai atsakyti į jūsų klausimą iš savo žinių bazės. Čia yra svarbiausias turinys, kurį radau.',
        'Jūsų klausimas negalėjo būti atsakytas tiesiogiai iš mano žinių bazės. Čia yra geriausia informacija, kurią radau.',
        'Aš neradau tiesioginio atsakymo į jūsų klausimą savo žinių bazėje. Čia yra svarbiausios detalės, kurias galėjau surinkti.',
    ],
    ka: [
        'ვერ შევძელი პირდაპირ პასუხის გაცემა თქვენს შეკითხვაზე ჩემი ცოდნის ბაზიდან. აი, ყველაზე შესაბამისი შინაარსი, რომელიც ვიპოვე.',
        'თქვენი შეკითხვა ვერ პასუხობს პირდაპირ ჩემი ცოდნის ბაზიდან. აი, საუკეთესო ინფორმაცია, რომელიც ვიპოვე.',
        'ვერ ვიპოვე პირდაპირი პასუხი თქვენს შეკითხვაზე ჩემი ცოდნის ბაზაში. აი, ყველაზე შესაბამისი დეტალები, რომლებიც შევაგროვე.',
    ],
    kk: [
        'Мен сіздің сұрағыңызға тікелей өз білім базамнан жауап бере алмадым. Міне, мен тапқан ең өзекті мазмұн.',
        'Сұрағыңызға білім базамнан тікелей жауап беру мүмкін болмады. Міне, мен тапқан ең жақсы ақпарат.',
        'Білім базамнан сіздің сұрағыңызға тікелей жауап таба алмадым. Міне, мен жинаған ең өзекті мәліметтер.',
    ],
    uz: [
        "Men savolingizga o'z bilim bazamdan bevosita javob bera olmadim. Mana men topgan eng dolzarb tarkib.",
        "Savolingizga bilim bazamdan to'g'ridan-to'g'ri javob berishning imkoni bo'lmadi. Mana men topgan eng yaxshi ma'lumot.",
        "Bilim bazamda savolingizga to'g'ridan-to'g'ri javob topa olmadim. Mana men to'plagan eng dolzarb tafsilotlar.",
    ],
};

export const no_rag_fallback_strings = {
    en: 'This is an AI-generated answer to your question that IS NOT based on your experimental-knowledge base.',
    de: 'Dies ist eine KI-generierte Antwort auf Ihre Frage, die NICHT auf Ihrer Wissensdatenbank basiert.',
    es: 'Esta es una respuesta generada por IA a su pregunta que NO se basa en su base de conocimientos.',
    fr: "Ceci est une réponse générée par IA à votre question qui N'EST PAS basée sur votre base de connaissances.",
    it: "Questa è una risposta generata dall'IA alla tua domanda che NON si basa sulla tua base di conoscenza.",
    pt: 'Esta é uma resposta gerada por IA à sua pergunta que NÃO se baseia na sua base de conhecimento.',
    nl: 'Dit is een door AI gegenereerd antwoord op uw vraag dat NIET is gebaseerd op uw kennisbank.',
    ru: 'Это сгенерированный ИИ ответ на ваш вопрос, который НЕ основан на вашей базе знаний',
    zh: '这是针对您的问题的 AI 生成的答案，并非基于您的知识库',
    ja: 'これはあなたの質問に対するAI生成の回答で、あなたの知識ベースに基づいていません',
    ko: '이것은 귀하의 질문에 대한 AI 생성 답변이며 귀하의 지식 기반에 기반하지 않습니다',
    ar: 'هذه إجابة تم إنشاؤها بواسطة الذكاء الاصطناعي لسؤالك وليست مستندة إلى قاعدة معارفك',
    hi: 'यह आपके प्रश्न का AI द्वारा उत्पन्न उत्तर है जो आपके ज्ञान आधार पर आधारित नहीं है',
    bn: 'এটি আপনার প্রশ্নের একটি AI-সৃষ্ট উত্তর যা আপনার জ্ঞানভান্ডারের উপর ভিত্তি করে নয়',
    ur: 'یہ آپ کے سوال کا AI سے تیار کردہ جواب ہے جو آپ کے علمی بنیاد پر مبنی نہیں ہے',
    tr: 'Bu, sorunuza yapay zeka tarafından oluşturulmuş ve bilgi tabanınıza DAYANMAYAN bir cevaptır',
    sv: 'Det här är ett AI-genererat svar på din fråga som INTE baseras på din kunskapsbas',
    no: 'Dette er et AI-generert svar på spørsmålet ditt som IKKE er basert på din kunnskapsbase',
    da: 'Dette er et AI-genereret svar på dit spørgsmål, som IKKE er baseret på din vidensbase',
    fi: 'Tämä on tekoälyn luoma vastaus kysymykseesi, joka EI perustu tietokantaasi',
    pl: 'To jest wygenerowana przez AI odpowiedź na twoje pytanie, która NIE opiera się na twojej bazie wiedzy',
    cs: 'Toto je odpověď generovaná AI na vaši otázku, která NENÍ založena na vaší znalostní bázi',
    sk: 'Toto je odpoveď generovaná AI na vašu otázku, ktorá NIE JE založená na vašej báze znalostí',
    hu: 'Ez egy mesterséges intelligencia által generált válasz a kérdésére, amely NEM az Ön tudásbázisán alapul',
    ro: 'Acesta este un răspuns generat de AI la întrebarea dvs. care NU se bazează pe baza dvs. de cunoștințe',
    bg: 'Това е генериран от AI отговор на вашия въпрос, който НЕ се базира на вашата база знания',
    el: 'Αυτή είναι μια απάντηση που δημιουργήθηκε από AI στην ερώτησή σας που ΔΕΝ βασίζεται στη βάση γνώσεών σας',
    he: 'זו תשובה שנוצרה על ידי בינה מלאכותית לשאלתך שאינה מבוססת על בסיס הידע שלך',
    fa: 'این پاسخی است که توسط هوش مصنوعی برای سؤال شما تولید شده و بر اساس پایگاه دانش شما نیست',
    id: 'Ini adalah jawaban yang dihasilkan AI untuk pertanyaan Anda yang TIDAK didasarkan pada basis pengetahuan Anda',
    ms: 'Ini adalah jawapan yang dijana AI kepada soalan anda yang TIDAK berdasarkan pangkalan pengetahuan anda',
    th: 'นี่คือคำตอบที่สร้างโดย AI สำหรับคำถามของคุณที่ไม่ได้อ้างอิงจากฐานความรู้ของคุณ',
    vi: 'Đây là câu trả lời được tạo bởi AI cho câu hỏi của bạn mà KHÔNG dựa trên cơ sở kiến thức của bạn',
    tl: 'Ito ay isang sagot na nalikha ng AI sa iyong tanong na HINDI batay sa iyong base ng kaalaman',
    uk: 'Це згенерована ШІ відповідь на ваше запитання, яка НЕ базується на вашій базі знань',
    be: 'Гэта згенераваны ІІ адказ на ваша пытанне, які НЕ заснаваны на вашай базе ведаў',
    sr: 'Ово је одговор генерисан вештачком интелигенцијом на ваше питање који НИЈЕ заснован на вашој бази знања',
    hr: 'Ovo je AI-generiran odgovor na vaše pitanje koji NIJE temeljen na vašoj bazi znanja',
    sl: 'To je odgovor, ki ga je ustvarila umetna inteligenca na vaše vprašanje in NI osnovan na vaši bazi znanja',
    mk: 'Ова е одговор генериран од АИ на вашето прашање кој НЕ се базира на вашата база на знаење',
    sq: 'Kjo është një përgjigje e gjeneruar nga AI për pyetjen tuaj që NUK bazohet në bazën tuaj të njohurive',
    et: 'See on teie küsimusele AI-ga genereeritud vastus, mis EI põhine teie teadmistebaasil',
    lv: 'Šī ir mākslīgā intelekta ģenerēta atbilde uz jūsu jautājumu, kas NAV balstīta uz jūsu zināšanu bāzi',
    lt: 'Tai yra AI sugeneruotas atsakymas į jūsų klausimą, kuris NĖRA pagrįstas jūsų žinių baze',
    ka: 'ეს არის თქვენი შეკითხვის AI-ით გენერირებული პასუხი, რომელიც არ ემყარება თქვენს ცოდნის ბაზას',
    kk: 'Бұл сіздің сұрағыңызға ЖИ арқылы жасалған жауап, ол сіздің білім қорыңызға негізделмеген',
    uz: 'Bu sizning savolingizga AI tomonidan yaratilgan javob bo‘lib, u sizning bilim bazangizga asoslanmagan',
};
